import {
    GetProductCollectionApiV2Parameter,
    GetRelatedProductCollectionApiV2Parameter,
} from "@insite/client-framework/Services/ProductServiceV2";
import {
    getComputedVariantProduct as baseGetComputedVariantProduct,
    getProductState,
    getProductStateByPath,
} from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { getDataView } from "@store/Store/Data/DataState";
import StoreApplicationState from "@store/Store/StoreApplicationState";

export const getComputedVariantProduct = (
    parentProductState: ReturnType<typeof getProductStateByPath>,
    variantProductState: ReturnType<typeof getProductState>,
) => {
    const productDataView = baseGetComputedVariantProduct(parentProductState, variantProductState);

    if (productDataView === parentProductState) {
        return productDataView;
    }

    const { value: variantProduct } = variantProductState;

    ["attributeTypes", "content", "detail", "documents", "images", "specifications", "properties"].forEach(x => {
        const variantValue = (variantProduct as any)?.[x];
        if (variantValue) {
            (productDataView as any).value[x] = variantValue;
        }
    });

    return productDataView;
};

export function getProductsDataView(
    state: StoreApplicationState,
    getProductsParameter?: GetProductCollectionApiV2Parameter | GetRelatedProductCollectionApiV2Parameter,
) {
    return getDataView(state.data.products, getProductsParameter);
}
